import { useSelector } from 'react-redux';

export default function useAuthUser() {
  const { user, isAuthenticated, loading } = useSelector((state) => state.auth);
  return { user, isAuthenticated, loading };
}
